'use es6';

export const SHOW_DELETED_MESSAGES = 'SHOW_DELETED_MESSAGES';
export const HIDE_DELETED_MESSAGES = 'HIDE_DELETED_MESSAGES';